/* Rute Soft — theme scripts (no dependencies) */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var routes = (window.theme && window.theme.routes) || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', root: '/' };
  var strings = (window.theme && window.theme.strings) || { addToCart: 'Add to Bag', soldOut: 'Sold out', unavailable: 'Unavailable' };

  /* ---------------- Drawers (menu + cart) ---------------- */
  var lastFocus = null;
  function openDrawer(name) {
    var d = $('[data-drawer="' + name + '"]');
    if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var focusTarget = $('[data-drawer-close].icon-btn', d);
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 50);
    return true;
  }
  function closeDrawers() {
    $$('[data-drawer].is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { e.preventDefault(); openDrawer('menu'); }
    if (e.target.closest('[data-cart-open]')) {
      if (window.theme && window.theme.cartDrawer === false) return;
      if (openDrawer('cart')) e.preventDefault();
    }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------------- Cart (Section Rendering API) ---------------- */
  function renderCart(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = html.querySelector('#CartDrawer');
    var current = $('#CartDrawer');
    if (fresh && current) {
      var wasOpen = current.classList.contains('is-open');
      current.innerHTML = fresh.innerHTML;
      if (wasOpen) current.classList.add('is-open');
      var countEl = $('[data-drawer-count]', current);
      updateCount(countEl ? parseInt(countEl.getAttribute('data-drawer-count'), 10) : null);
      localizeShipBar();
    }
  }
  /* Free shipping bar: the threshold is saved in the store currency, so convert it to the shopper's currency */
  function localizeShipBar() {
    var bar = document.querySelector('[data-ship-bar]');
    if (!bar) return;
    var cur = window.Shopify && window.Shopify.currency;
    var rate = cur ? parseFloat(cur.rate) : 1;
    if (!rate || isNaN(rate)) rate = 1;
    var threshold = Math.round(parseInt(bar.getAttribute('data-ship-threshold'), 10) * rate);
    var total = parseInt(bar.getAttribute('data-cart-total'), 10);
    if (!threshold || isNaN(total)) { bar.classList.remove('is-converting'); return; }
    var remaining = threshold - total;
    var pct = Math.max(0, Math.min(100, Math.floor(total * 100 / threshold)));
    var reward = bar.getAttribute('data-reward') || '';
    var text = bar.querySelector('.cart-ship__text');
    var fill = bar.querySelector('.cart-ship__bar span');
    if (fill) fill.style.width = pct + '%';
    bar.classList.toggle('is-unlocked', remaining <= 0);
    if (text) {
      if (remaining <= 0) {
        text.textContent = "You've unlocked " + reward + '!';
      } else {
        var amount;
        try {
          amount = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: (cur && cur.active) || 'USD', currencyDisplay: 'narrowSymbol' }).format(remaining / 100);
        } catch (e) { amount = (remaining / 100).toFixed(2); }
        text.innerHTML = "You're <strong></strong> away from ";
        text.querySelector('strong').textContent = amount;
        text.appendChild(document.createTextNode(reward));
      }
    }
    bar.classList.remove('is-converting');
  }
  localizeShipBar();
  function updateCount(n) {
    if (n === null || isNaN(n)) return;
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    var list = $('.cart-items');
    if (list) list.classList.add('is-busy');
    fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(btn.getAttribute('data-line-change'), 10), quantity: parseInt(btn.getAttribute('data-qty'), 10), sections: ['cart-drawer'], sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { renderCart(data.sections); })
      .catch(function () { window.location.href = routes.cart; });
  });

  /* ---------------- Announcement bar ---------------- */
  $$('[data-ann]').forEach(function (bar) {
    var msgs = $$('.ann__msg', bar);
    if (msgs.length < 2) return;
    var i = 0, timer;
    var speed = (parseInt(bar.getAttribute('data-speed'), 10) || 5) * 1000;
    function show(n) {
      msgs[i].classList.remove('is-active');
      i = (n + msgs.length) % msgs.length;
      msgs[i].classList.add('is-active');
    }
    function start() { clearInterval(timer); timer = setInterval(function () { show(i + 1); }, speed); }
    var prev = $('[data-ann-prev]', bar), next = $('[data-ann-next]', bar);
    if (prev) prev.addEventListener('click', function () { show(i - 1); start(); });
    if (next) next.addEventListener('click', function () { show(i + 1); start(); });
    start();
  });

  /* ---------------- Dialogs (size guide) ---------------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-dialog-open]');
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-dialog-open'));
      if (dlg && dlg.showModal) dlg.showModal();
    }
    var closer = e.target.closest('[data-dialog-close]');
    if (closer) { var d = closer.closest('dialog'); if (d) d.close(); }
    if (e.target.tagName === 'DIALOG') e.target.close();
  });

  /* ---------------- Product section ---------------- */
  function initProduct(root) {
    if (!root || root.__init) return;
    root.__init = true;

    // Gallery: slides peek the next image; a progress line shows the current image
    var track = $('[data-gallery-track]', root);
    var slides = track ? $$('.gallery__slide', track) : [];
    var thumbs = $$('[data-thumb-index]', root);
    var active = 0;
    var progressFill = null;
    if (track && slides.length > 1) {
      var viewport = track.closest('.gallery__viewport');
      var bar = document.createElement('div');
      bar.className = 'gallery__progress';
      bar.setAttribute('aria-hidden', 'true');
      progressFill = document.createElement('span');
      progressFill.style.width = (100 / slides.length) + '%';
      bar.appendChild(progressFill);
      if (viewport) viewport.appendChild(bar);
    }
    function padLeft() { return track ? parseFloat(getComputedStyle(track).paddingLeft) || 0 : 0; }
    function targetLeft(n) {
      var max = track.scrollWidth - track.clientWidth;
      return Math.max(0, Math.min(max, slides[n].offsetLeft - padLeft()));
    }
    function setActive(n) {
      active = n;
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === n); });
      if (progressFill) progressFill.style.transform = 'translateX(' + (n * 100) + '%)';
      var t = thumbs[n];
      if (t && t.parentElement && t.parentElement.parentElement) {
        var strip = t.parentElement.parentElement;
        strip.scrollTo({ left: t.parentElement.offsetLeft - strip.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
      }
    }
    function goTo(n) {
      if (!track || !slides.length) return;
      n = Math.max(0, Math.min(slides.length - 1, n));
      track.scrollTo({ left: targetLeft(n), behavior: 'smooth' });
      setActive(n);
    }
    function nearest() {
      var x = track.scrollLeft;
      if (x >= track.scrollWidth - track.clientWidth - 2) return slides.length - 1;
      var best = 0, dist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(targetLeft(i) - x);
        if (d < dist) { dist = d; best = i; }
      }
      return best;
    }
    if (track) {
      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var n = nearest();
          if (n !== active) setActive(n);
        }, 60);
      }, { passive: true });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-thumb-index'), 10)); }); });
    var prev = $('[data-gallery-prev]', root), next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', function () { goTo(active - 1); });
    if (next) next.addEventListener('click', function () { goTo(active + 1); });

    // Kaching bundles: picking a colour in a bundle bar slides the gallery to that colour's photo
    var colorMap = {};
    var mapEl = $('[data-color-media-map]', root);
    if (mapEl) { try { colorMap = JSON.parse(mapEl.textContent); } catch (e) { colorMap = {}; } }
    function showColor(val) {
      var mid = colorMap[val];
      if (!mid || !slides.length) return;
      for (var k = 0; k < slides.length; k++) {
        if (String(slides[k].getAttribute('data-media-id')) === String(mid)) { goTo(k); return; }
      }
    }
    if (Object.keys(colorMap).length && track) {
      var touched = false, lastColors = null, pending = false;
      var colorSel = 'kaching-bundle [data-name="Color"], kaching-bundle [data-name="Colour"]';
      var readColors = function () {
        return $$(colorSel).map(function (el) { return el.getAttribute('data-value') || el.value || ''; });
      };
      var onMutate = function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          var now = readColors();
          if (touched && lastColors && now.length === lastColors.length) {
            for (var i = 0; i < now.length; i++) {
              if (now[i] !== lastColors[i]) { showColor(now[i]); break; }
            }
          }
          lastColors = now;
        });
      };
      var markTouched = function (e) { if (e.target && e.target.closest && e.target.closest('kaching-bundle')) touched = true; };
      document.addEventListener('pointerdown', markTouched, true);
      document.addEventListener('keydown', markTouched, true);
      document.addEventListener('change', function (e) {
        var t = e.target;
        if (t && t.matches && t.matches('kaching-bundle select[data-name="Color"], kaching-bundle select[data-name="Colour"]')) showColor(t.value);
      }, true);
      var tries = 0;
      var waitForKaching = setInterval(function () {
        var kb = $$('kaching-bundle');
        if (kb.length || ++tries > 40) {
          clearInterval(waitForKaching);
          if (!kb.length) return;
          lastColors = readColors();
          var mo = new MutationObserver(onMutate);
          kb.forEach(function (el) { mo.observe(el, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-value'] }); });
        }
      }, 250);
    }

    // Quantity
    $$('[data-qty]', root).forEach(function (q) {
      var input = $('input', q);
      if (!input) return;
      var minus = $('[data-qty-minus]', q), plus = $('[data-qty-plus]', q);
      if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
    });

    // Variants
    var jsonEl = $('[data-variant-json]', root);
    var variants = [];
    try { variants = jsonEl ? JSON.parse(jsonEl.textContent) : []; } catch (err) { variants = []; }
    var idInput = $('[data-variant-id]', root);
    var addBtn = $('[data-add-btn]', root);
    var addText = $('[data-add-text]', root);
    var priceEl = $('[data-price]', root), compareEl = $('[data-compare]', root);
    var saveEl = $('[data-save]', root), savePct = $('[data-save-pct]', root);
    var stickyPrice = $('[data-sticky-price]', root);
    var fieldsets = $$('.opt[data-option-position]', root);
    var defaultLabel = addText ? addText.textContent.trim() : strings.addToCart;

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var c = $('input:checked', fs);
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function markAvailability(opts) {
      // Grey out values that have no available variant given the other selections
      fieldsets.forEach(function (fs, pos) {
        $$('input', fs).forEach(function (input) {
          var test = opts.slice(); test[pos] = input.value;
          var v = findVariant(test);
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function updateVariant() {
      var opts = selectedOptions();
      fieldsets.forEach(function (fs, idx) {
        var lbl = $('[data-option-selected]', fs);
        if (lbl) lbl.textContent = opts[idx] || '';
      });
      markAvailability(opts);
      var v = findVariant(opts);
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addText) addText.textContent = strings.unavailable;
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price;
      if (stickyPrice) stickyPrice.innerHTML = v.price;
      if (compareEl) { compareEl.hidden = !v.compare; if (v.compare) compareEl.innerHTML = v.compare; }
      if (saveEl) { saveEl.hidden = !v.save; if (savePct) savePct.textContent = v.save; }
      if (addBtn) addBtn.disabled = !v.available;
      if (addText) addText.textContent = v.available ? defaultLabel : strings.soldOut;
      if (v.media && slides.length) {
        for (var k = 0; k < slides.length; k++) {
          if (String(slides[k].getAttribute('data-media-id')) === String(v.media)) { goTo(k); break; }
        }
      }
      var url = root.getAttribute('data-url');
      if (url && document.body.classList.contains('template-product')) {
        history.replaceState({}, '', url + '?variant=' + v.id);
      }
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', updateVariant); });
    if (fieldsets.length) markAvailability(selectedOptions());

    // Add to cart (AJAX → cart drawer)
    var form = $('[data-product-form]', root);
    var errorEl = $('[data-form-error]', root);
    if (form) {
      form.addEventListener('submit', function (e) {
        if (window.theme && window.theme.cartDrawer === false) return; // fall back to normal submit → cart page
        e.preventDefault();
        if (!addBtn || addBtn.disabled) return;
        addBtn.classList.add('is-loading');
        if (errorEl) errorEl.hidden = true;
        var fd = new FormData(form);
        fd.append('sections', 'cart-drawer');
        fd.append('sections_url', window.location.pathname);
        fetch(routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.status && data.status !== 200) {
              if (errorEl) { errorEl.textContent = data.description || data.message || 'Something went wrong.'; errorEl.hidden = false; }
              return;
            }
            renderCart(data.sections);
            openDrawer('cart');
          })
          .catch(function () { form.submit(); })
          .finally(function () { addBtn.classList.remove('is-loading'); });
      });
    }

    // Sticky add-to-cart bar
    var sticky = $('[data-sticky-atc]', root);
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var footer = $('.footer');
      var buyVisible = true, footerVisible = false;
      var refresh = function () {
        var show = !buyVisible && !footerVisible;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      };
      new IntersectionObserver(function (entries) {
        buyVisible = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
        refresh();
      }).observe(addBtn);
      if (footer) new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; refresh(); }).observe(footer);
      var stickyBtn = $('[data-sticky-add]', sticky);
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        // Always take shoppers to the top of the page to choose tone & size (never the cart drawer)
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  }

  /* ---------------- Reveal-on-scroll ---------------- */
  function initReveal(ctx) {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.section .sh, .review, .feature, .stat, .compare, .split__media, .guarantee__media, .acc--card', ctx).forEach(function (el) {
      if (Shopify && Shopify.designMode) return;
      el.classList.add('reveal');
      io.observe(el);
    });
  }

  function init(ctx) {
    $$('[data-product]', ctx).forEach(initProduct);
    // Scroll-in fade animations are turned off: every section's content shows instantly on page load.
  }

  window.Shopify = window.Shopify || {};
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Photos further down the page: as soon as the first screen has finished loading, download all of them in the
     background, so every section is already fully shown when a shopper gets there, however they scroll
     (mouse wheel, trackpad, scrollbar, keyboard or swipe). */
  function preloadAllImages() {
    $$('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  }
  if (document.readyState === 'complete') { setTimeout(preloadAllImages, 0); }
  else { window.addEventListener('load', function () { setTimeout(preloadAllImages, 0); }); }

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* ---------------- Cart drawer countdown (5 min, then holds at 00:00) ---------------- */
  (function cartTimer() {
    var KEY = 'rute_cart_timer_end';
    function fmt(ms) {
      if (ms < 0) ms = 0;
      var m = Math.floor(ms / 60000), s = Math.floor((ms % 60000) / 1000);
      return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    }
    function tick() {
      var el = document.querySelector('[data-cart-timer]');
      if (!el) return;
      var end;
      try { end = parseInt(sessionStorage.getItem(KEY) || '0', 10); } catch (e) { end = 0; }
      if (!end) {
        var mins = parseInt(el.getAttribute('data-minutes'), 10) || 5;
        end = Date.now() + mins * 60000;
        try { sessionStorage.setItem(KEY, String(end)); } catch (e) {}
      }
      el.textContent = fmt(end - Date.now());
    }
    setInterval(tick, 1000);
    tick();
  })();
})();
